import React from "react";
// import { RouteChildrenProps } from "react-router-dom";
import regbanner from "../../../assets/icons/docsRejected.png";
import Button from "../../UI/Button/Button";
import ProfileImage from "../../UI/ProfileImage/ProfileImage";
import GlobalStore from "../../store/globalStore";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { dashboardUrl, containerUrl } from "../../utils/constants";
import {
  completeModuleStatus,
  setStageData,
} from "../../Services/globalService";
import welcomeBack from "../../../assets/icons/welcomeBack.jpg";
import { checkModuleCompleteness } from "../../Profile/ProfileNavBar/ProfileNavBar";
import {
  AGetClientDetailsByPan,
  AGetPanUtiData,
} from "../../Services/registration/panDobApiService";

import "./DocumentReject.scss";
import { errorMessage } from "../../utils/errorMessage";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { APendingUploadList } from "../../Services/dashboard/eSignApiServices";

export interface DocumentRejectProps { }

const DocumentReject: React.FC<DocumentRejectProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [clientName, setClientName] = React.useState<string>("");
  const [errCode, setErrCode] = React.useState<number | string>();
  const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);
  const [addressRejctedFound, setAddressRejctedFound] =
    React.useState<any>(null);
  // const history = useHistory();
  const navigate = useNavigate()
  let isUploadDocumentsCompleted = false;
  const handleContinue = () => {
    // e.preventDefault();
    console.log("Continue....");
    setIsLoading(true);
    sessionStorage.removeItem("isESignSubmitted");
    const panFromLocalStorage = JSON.parse(
      window.sessionStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    let panNum = GlobalStore.personaldetails.pan;
    if (
      GlobalStore.personaldetails.pan != undefined ||
      GlobalStore.personaldetails.pan != ""
    ) {
      panNum = GlobalStore.personaldetails.pan;
    } else if (panFromLocalStorage.pan != "") {
      panNum = panFromLocalStorage.pan != "" ? panFromLocalStorage.pan : "";
    }
    AGetPanUtiData(validatePAN, panNum);
  };

  // function validatePAN(res: any) {
  //   if (!res || res.error) {
  //     // setErrCode(107);
  //     // setErrCode(errorMessage.validatePAN);
  //     console.log(res.errMsg);
  //     setErrCode(res.error);
  //     setIsLoading(false);
  //   } else {
  //     if (
  //       res &&
  //       res.data &&
  //       res.data.panDetails &&
  //       res.data.panDetails?.AadharSeedingStatus.indexOf(
  //         "Existing and Valid"
  //       ) !== -1
  //     ) {
  //       let PANFirstName = res.data.panDetails.Firstname
  //         ? res.data.panDetails.Firstname
  //         : "";
  //       let PANMiddleName = res.data.panDetails.Middlename
  //         ? res.data.panDetails.Middlename
  //         : "";
  //       let PANlastName = res.data.panDetails.Lastname
  //         ? res.data.panDetails.Lastname
  //         : "";

  //       if (PANFirstName === "null" && PANlastName !== "null") {
  //         PANFirstName = PANlastName;
  //         GlobalStore.personaldetails.PANName = PANFirstName;
  //         PANlastName = "";
  //         if (PANMiddleName !== "null") {
  //           GlobalStore.personaldetails.PANName =
  //             GlobalStore.personaldetails.PANName + " " + PANMiddleName;
  //         }
  //       } else if (
  //         PANFirstName === "null" &&
  //         PANMiddleName === "null" &&
  //         PANlastName === "null"
  //       ) {
  //         GlobalStore.personaldetails.PANName = "";
  //       } else if (PANMiddleName === "null") {
  //         GlobalStore.personaldetails.PANName =
  //           PANFirstName + " " + PANlastName;
  //         PANMiddleName = "";
  //       } else {
  //         GlobalStore.personaldetails.PANName =
  //           PANFirstName + " " + PANMiddleName + " " + PANlastName;
  //       }

  //       //Modify personal details based on this response.

  //       GlobalStore.personaldetails.firstname = PANFirstName;
  //       GlobalStore.personaldetails.lastname = PANlastName;
  //       GlobalStore.personaldetails.middlename = PANMiddleName;
  //       GlobalStore.personaldetails.panDetails = res.data.panDetails;
  //       AGetClientDetailsByPan(searchByPan, GlobalStore.personaldetails.pan);
  //     } else if (
  //       res &&
  //       res.data &&
  //       res.data.panDetails &&
  //       res.data.panDetails?.AadharSeedingStatus.indexOf("Invalid PAN") === -1
  //     ) {
  //       setErrCode(errorMessage.newPanUtiError);
  //       setIsLoading(false);
  //     } else if (
  //       res &&
  //       res.data &&
  //       res.data.panDetails &&
  //       res.data.panDetails?.AadharSeedingStatus.indexOf(
  //         "Not in ITD Database"
  //       ) === -1
  //     ) {
  //       setErrCode(errorMessage.newPanUtiError);
  //       setIsLoading(false);
  //     } else {
  //       setErrCode(errorMessage.newPanUtiError);
  //       setIsLoading(false);
  //     }
  //   }
  // }

  function validatePAN(res: any) {
    if (!res || res.error) {
      // setErrCode('107  - Error in fetching Pan details from PAN UTI system.');
      setErrCode(res.error);
      console.log(res.errMsg);
      setIsLoading(false);
    } else {
      if (res && res.data && res.data.PanNo && res.data.IsValid == true) {
        //CleverTap log Start
        // var data = {
        //     CurrentPage: $location.path(),
        //     Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
        //     EventName: 'pan_dob_success',
        //     CTA: 'Continue'
        // };
        // clevertap.event.push(data.EventName, data);
        //CleverTap log End

        let PANFirstName = res.data.Firstname ? res.data.Firstname : "";
        let PANMiddleName = res.data.Middlename ? res.data.Middlename : "";
        let PANlastName = res.data.Lastname ? res.data.Lastname : "";

        if (PANFirstName === "" && PANlastName !== "") {
          PANFirstName = PANlastName;
          GlobalStore.personaldetails.PANName = PANFirstName;
          PANlastName = "";
          if (PANMiddleName !== "") {
            GlobalStore.personaldetails.PANName =
              GlobalStore.personaldetails.PANName + " " + PANMiddleName;
          }
        } else if (
          PANFirstName === "" &&
          PANMiddleName === "" &&
          PANlastName === ""
        ) {
          GlobalStore.personaldetails.PANName = "";
        } else if (PANMiddleName === "") {
          GlobalStore.personaldetails.PANName =
            PANFirstName + " " + PANlastName;
          PANMiddleName = "";
        } else {
          GlobalStore.personaldetails.PANName =
            PANFirstName + " " + PANMiddleName + " " + PANlastName;
        }

        //Modify personal details based on this response.

        GlobalStore.personaldetails.firstname = PANFirstName;
        GlobalStore.personaldetails.lastname = PANlastName;
        GlobalStore.personaldetails.middlename = PANMiddleName;
        GlobalStore.personaldetails.panDetails = res.data;

        let responseObj = res.data.AadharSeedingStatus
          ? res.data.AadharSeedingStatus
          : "";

        if (responseObj.includes("Aadhaar not Seeded")) {
          GlobalStore.isSeeding = false;
        } else if (responseObj.includes("Aadhaar Seeding is Successful")) {
          GlobalStore.isSeeding = true;
        }

        //-------- After Pan validation Navigate to DigiLocker Page -------
        let userId = "0";

        const tokenObj: string = decryptJwtToken(GlobalStore?.token);
        if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
          let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
          userId = tokenMainObj?.UserId?.toString();
        }
        AGetClientDetailsByPan(
          searchByPan,
          GlobalStore.personaldetails.pan,
          GlobalStore?.stageStatus?.accountcategory,
          userId
        );
        //Dudupe Logic here//
      } else if (
        res &&
        res.data &&
        res.data.PanNo &&
        res.data.IsValid == false
      ) {
        // setErrCode('Not in ITD Database. Please enter valid PAN.');
        setErrCode(res.error);
        setIsLoading(false);
        //CleverTap log start
        // var data = {
        //     CurrentPage: $location.path(),
        //     Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
        //     EventName: 'pan_dob_failure',
        //     Error: 'Not in ITD Database.Please enter valid PAN'
        // };
        // clevertap.event.push(data.EventName, data);
        //CleverTap log end
        // } else if (
        //     res &&
        //     res.data &&
        //     res.data.panDetails &&
        //     res.data.panDetails.indexOf('Not in ITD Database') === -1
        // ) {
        //     // setErrCode('Not in ITD Database.Please enter valid PAN.');
        //     setErrCode(errorMessage.clientDetailsByPan);
        //     setIsLoading(false);
        //CleverTap log start
        // var data = {
        //     CurrentPage: $location.path(),
        //     Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
        //     EventName: 'pan_dob_failure',
        //     Error: 'Not in ITD Database.Please enter valid PAN'
        // };
        // clevertap.event.push(data.EventName, data);
        //CleverTap log end
      } else {
        // setErrCode('PAN UTI server down');
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  }

  const searchByPan = (res: any) => {
    if (!res || res.error) {
      // setErrCode(118);
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data) {
        if (res.data != null) {
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.accountcategory = res.AccountCategory;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.leadId = res.data.LeadId;

          const clientPartialDetails_ao = JSON.parse(
            window.sessionStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          clientPartialDetails_ao.pan = res.data.PAN;
          clientPartialDetails_ao.emailID = GlobalStore.user.email;
          clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
          clientPartialDetails_ao.clientPrimaryDetailId =
            res.data.ClientPrimaryDetailId;
          clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
          clientPartialDetails_ao.token = GlobalStore.token;
          clientPartialDetails_ao.leadID = GlobalStore.leadId;
          clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
          clientPartialDetails_ao.accountcategory = res.AccountCategory;
          window.sessionStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );
          redirectToDematPage();
        } else if (res.data == null) {
          setErrCode("No records found");
        }
      } else {
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  };
  const redirectToDematPage = () => {
    let dematAccountFoundLocal: any = null,
      addressAccountFoundLocal: any = null;
    APendingUploadList((res: any) => {
      if (!res || res.error) {
        setErrCode(res.error);
      } else {
        if (res && res.data) {
          let resultObj = JSON.parse(res.data);
          let list: Array<any> = resultObj.filter(
            (item: any) =>
              // prev api types
              // item.documentcategoryid !== 36 &&
              // item.documentcategoryid !== 30 &&
              // item.documentcategoryid !== 62
              // item.DocumentCategoryId !== 36 &&
              // item.DocumentCategoryId !== 30 &&
              // item.DocumentCategoryId !== 62
              item.Mandatory == true
          );

          if (
            list !== undefined &&
            list !== null &&
            list?.length > 0 &&
            list?.length === 1
          ) {
            addressAccountFoundLocal = list.find(
              (listObj) =>
                (listObj?.DocumentCategory == "Address Proof Permanent" &&
                  listObj?.DocumentCategoryId == 4) ||
                (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                  listObj?.DocumentCategoryId == 3)
            );
            dematAccountFoundLocal = list.find(
              (listObj) =>
                listObj?.DocumentCategory == "DP Document" &&
                listObj?.DocumentCategoryId == 96
            );
            if (
              dematAccountFoundLocal !== undefined &&
              dematAccountFoundLocal !== null
            ) {
              setDematAccountFound((dematAccountFound: any) => {
                dematAccountFound = dematAccountFoundLocal;
                return dematAccountFound;
              });
              //  completeModuleStatus(dashboardUrl.demat);
              // history.push(dashboardUrl.demat);
              // return;
            }
          }
          if (
            list !== undefined &&
            list !== null &&
            list?.length > 0 &&
            list?.length > 1
          ) {
            addressAccountFoundLocal = list.find(
              (listObj) =>
                (listObj?.DocumentCategory == "Address Proof Permanent" &&
                  listObj?.DocumentCategoryId == 4) ||
                (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                  listObj?.DocumentCategoryId == 3)
            );
            dematAccountFoundLocal = list.find(
              (listObj) =>
                listObj?.DocumentCategory == "DP Document" &&
                listObj?.DocumentCategoryId == 96
            );
            if (
              dematAccountFoundLocal !== undefined &&
              dematAccountFoundLocal !== null
            ) {
              setDematAccountFound((dematAccountFound: any) => {
                dematAccountFound = dematAccountFoundLocal;
                return dematAccountFound;
              });
              //  completeModuleStatus(dashboardUrl.demat);
              // history.push(dashboardUrl.demat);
              // return;
            }
          }
          if (list.length === 0 || list[0].count === 0)
            isUploadDocumentsCompleted = true;
        } else {
          isUploadDocumentsCompleted = true;
        }
        AGetStageCompletionStatus((res: any) => {
          getClientStageDetails(
            res,
            dematAccountFoundLocal,
            addressAccountFoundLocal
          );
        }, GlobalStore.applicationID);
      }
      //setIsLoading(false);
    }, GlobalStore.applicationID);
  };

  function getClientStageDetails(
    res: any,
    dematAccountFoundLocaL?: any,
    addressRejctedFound?: any
  ) {
    setIsLoading(true);
    if (!res || res.error) {
      // setErrCode(106);
      setErrCode(res.error);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        let PANFirstName = res.data.Firstname ? res.data.Firstname : "";
        let PANMiddleName = res.data.Middlename ? res.data.Middlename : "";
        let PANlastName = res.data.Lastname ? res.data.Lastname : "";

        if (PANFirstName === "" && PANlastName !== "") {
          PANFirstName = PANlastName;
          GlobalStore.personaldetails.PANName = PANFirstName;
          PANlastName = "";
          if (PANMiddleName !== "") {
            GlobalStore.personaldetails.PANName =
              GlobalStore.personaldetails.PANName + " " + PANMiddleName;
          }
        } else if (
          PANFirstName === "" &&
          PANMiddleName === "" &&
          PANlastName === ""
        ) {
          GlobalStore.personaldetails.PANName = "";
        } else if (PANMiddleName === "") {
          GlobalStore.personaldetails.PANName =
            PANFirstName + " " + PANlastName;
          PANMiddleName = "";
        } else {
          GlobalStore.personaldetails.PANName =
            PANFirstName + " " + PANMiddleName + " " + PANlastName;
        }
        GlobalStore.personaldetails.panDetails = {
          PanNo: res.data.PAN,
          Firstname: PANFirstName,
          Middlename: PANMiddleName,
          Lastname: PANlastName,
          PANIssueDate: "",
          AadharSeedingStatus: "",
          VendorName: "",
          IsValid: false,
          IsAadharSeeded: "",
        };
        //set stage api data to GlobalStore
        setStageData(responseObj);

        //check completeness of stages

        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound,
          addressRejctedFound
        );
        if (addressRejctedFound !== null && addressRejctedFound !== undefined) {
          let personalInfoIndex = GlobalStore.leftNavBarState.findIndex(
            (item) => item.name == "Personal Documents"
          );
          if (personalInfoIndex > -1) {
            GlobalStore.leftNavBarState[personalInfoIndex].isComplete = false;
          }
        }
        const clientPartialDetails_ao = JSON.parse(
          window.sessionStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.panDetails =
          GlobalStore.personaldetails.panDetails;
        clientPartialDetails_ao.emailID = responseObj.emailid;
        clientPartialDetails_ao.mobile = responseObj.mobileno;
        window.sessionStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        //route according to stage api response\
        if (responseObj.bpm_pd_status == 2 && addressRejctedFound) {
          // history.push(dashboardUrl.personalIfo);
          navigate(dashboardUrl.personalIfo)
          return;
        }
        if (
          dematAccountFoundLocaL !== null &&
          dematAccountFoundLocaL !== undefined
        ) {
          // history.push(dashboardUrl.demat);
          navigate(dashboardUrl.demat)
          return;
        }
        if (
          !responseObj.isdigilockercompleted &&
          GlobalStore.aadharLinkedChoice &&
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA
        ) {
          // history.push(containerUrl.dgLocker);
          navigate(containerUrl.dgLocker)
          return;
        }
        if (
          !(
            responseObj.isprofiledetailscompleted &&
            responseObj.ispersonaldetailscompleted
          )
        ) {
          // history.push(dashboardUrl.profile);
          navigate(dashboardUrl.profile)
          return;
        }
        if (!responseObj.isbankdetailscompleted) {
          // history.push(dashboardUrl.bank);
          navigate(dashboardUrl.bank)
          return;
        }
        if (responseObj?.accountcategory === 2 && !responseObj?.isdpcompleted) {
          // history.push(dashboardUrl.demat);
          navigate(dashboardUrl.demat)
          return;
        }
        if (
          responseObj?.accountcategory !== 2 &&
          (!responseObj.isbrokeragesegmentcompleted ||
            !responseObj.isbrokerageschemecompleted)
        ) {
          // history.push(dashboardUrl.plan);
          navigate(dashboardUrl.plan)
          return;
        }
        if (!isUploadDocumentsCompleted) {
          // history.push(dashboardUrl.doc);
          navigate(dashboardUrl.doc)
          return;
        }
        if (
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA &&
          // !GlobalStore.isKYC &&
          !responseObj.isipvarificationcompleted
        ) {
          // history.push(dashboardUrl.ipv);
          navigate(dashboardUrl.ipv)
          return;
        }
        if (responseObj.isagentvisitcompleted) {
          // history.push(containerUrl.ocv);
          navigate(containerUrl.ocv)
          return;
        }
        if (responseObj.isesigncompleted && !responseObj?.second_esign_req) {
          // history.push(containerUrl.submit);
          navigate(containerUrl.submit)
          return;
        }
        if (!responseObj.isesigncompleted) {
          // history.push(dashboardUrl.eSign);
          navigate(dashboardUrl.eSign)
          return;
        }
        if (responseObj.isesigncompleted) {
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa)
          return;
        }
      }
    }
    setIsLoading(false);
  }

  return (
    <div className="doc-reject-root">
      <img src={regbanner} className="verified-img" />
      <div>
        <h2 className="status-heading">Document Rejected</h2>
        {/* <span className="status-subHead">Please reupload the following documents</span>
                <ul className="doc-list">
                    <li>Correspondence Address Proof</li>
                    <li>Signature</li>
                </ul> */}
        <div className="login-btn">
          <Button btnName="Continue" type="submit" onClick={handleContinue} />
        </div>
      </div>
      <br />
      {errCode && (
        <div className="errMsgBlck">
          <ErrMsg>
            {typeof errCode === "number" ? (
              <>
                <label>We are facing some technical issue.</label>
                <label>Please try after sometime (error code:{errCode})</label>
              </>
            ) : (
              <label>{errCode}</label>
            )}
          </ErrMsg>
        </div>
      )}
    </div>
  );
};

export default DocumentReject;
